export function updateProducts(state, payload) {
  state.products = payload;
}
